"use client"
import type { EffectCallback } from "react"
import { useEffect } from "react"
/* Run a callback effect only once when the calling component mounts
 * @param effect Effect to be run only on mount
 */
export const useMountEffect = (effect: EffectCallback) => {
  useEffect(effect, [])
}
